<template>
  <div class="ProductDetails">
    <banner img="../assets/img/bgtop.jpg"/>
    <div class="ProductDetails-product">
      <div class="back-button">
        <img  width="25px" src="../assets/img/back.png" @click="goBack"/>
      </div>
      <div class="ProductDetails-product-content">
<!--        <img style="max-width: 50%" :src="imgserver+product.img" @click="openPhoto(imgserver+product.img)" alt/>-->
        <p class="product-title">{{ product.title }}</p>
        <div v-html="product.content"></div>
      </div>
    </div>
    <div>
      <!-- 大图模态框 -->
      <el-dialog
          :visible.sync="showLargeImage"
          @click="showLargeImage=false">
        <el-image :src="largeImageUrl" fit="fill"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  name: "ProductDetails",
  components: {
    Banner
  },
  data() {
    return {
      product: {},
      showLargeImage: false,
      largeImageUrl: ''
    };
  },
  created() {
    this.product.title = this.$route.params.title;
    this.product.img = this.$route.params.img;
    this.product.content = this.$route.params.content;
  },
  methods: {
    openPhoto(src) {
      this.showLargeImage = true;
      this.largeImageUrl = src;
    },
    goBack() {
      this.$router.go(-1);
      // window.history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.ProductDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;


  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    //text-align: center;

    .back-button {
      //position: absolute; /* 绝对定位 */
      left: 20px; /* 距离左侧的距离 */
      top: 20px; /* 距离顶部的距离 */
      cursor: pointer; /* 鼠标悬停时显示手型 */
    }

    &-content {
      //text-align: center;
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;

      img {
        width: 100%;
        //height: 500px;
      }

      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
        text-align: center;
      }

      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>
